import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer
      className="mt-24 pt-16 pb-10 px-6 md:px-10 relative"
      style={{ borderTop: "1px solid var(--gl-border)", background: "var(--gl-surface)" }}
      data-testid="site-footer"
    >
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="font-display text-3xl" data-testid="footer-brand">
            GraveLight <span style={{ color: "var(--gl-amber)" }}>Studio</span>
          </div>
          <p className="mt-3 max-w-sm text-sm" style={{ color: "var(--gl-muted)" }}>
            A film & design house for stories that refuse to stay buried. Atlanta, Georgia &nbsp;·&nbsp; Remote.
          </p>
          <div className="mt-6 flex flex-col gap-2">
            <a
              href="mailto:hello@gravelightstudio.com"
              className="gl-link text-xs tracking-[0.25em] uppercase"
              data-testid="footer-email-link"
            >
              hello@gravelightstudio.com
            </a>
            <a
              href="tel:+16784477382"
              className="gl-link text-xs tracking-[0.25em] uppercase"
              data-testid="footer-phone-link"
            >
              678-447-7382
            </a>
          </div>
        </div>

        <div>
          <div className="overline mb-3">Wander</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/projects" className="gl-link" data-testid="footer-link-projects">Services</Link></li>
            <li><Link to="/about" className="gl-link" data-testid="footer-link-about">About</Link></li>
            <li><Link to="/contact" className="gl-link" data-testid="footer-link-contact">Contact</Link></li>
          </ul>
        </div>

        <div>
          <div className="overline mb-3">Whispers</div>
          <ul className="space-y-2 text-sm">
            <li><a href="#" className="gl-link" data-testid="footer-link-instagram">Instagram</a></li>
            <li><a href="#" className="gl-link" data-testid="footer-link-vimeo">Vimeo</a></li>
            <li><a href="#" className="gl-link" data-testid="footer-link-letterboxd">Letterboxd</a></li>
          </ul>
        </div>
      </div>

      <div
        className="max-w-7xl mx-auto mt-12 pt-6 flex flex-col md:flex-row justify-between items-center text-xs"
        style={{ borderTop: "1px solid var(--gl-border)", color: "var(--gl-muted)" }}
      >
        <div>© {new Date().getFullYear()} GraveLight Studio — Where stories are unearthed.</div>
        <div className="mt-2 md:mt-0 tracking-[0.25em] uppercase">Carved in candlelight</div>
      </div>
    </footer>
  );
}
